import { Module } from 'vuex'

import { GetByEntryIdReviewListUseCase } from '@/application/review/getByEntryIdReviewListUseCase'
import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

interface ReviewPostEntryDetailState {
  reviewEntryDetailList: { [entryId: string]: ReviewEntryDetail[] }
  isLoading: boolean
  error: Error | null
}

export const reviewPostEntryDetailModule = (
  reviewEntryRepository: ReviewEntryRepository
): Module<ReviewPostEntryDetailState, any> => {
  const getByEntryIdReviewsUseCase = new GetByEntryIdReviewListUseCase(reviewEntryRepository)

  return {
    namespaced: true,
    state: {
      reviewEntryDetailList: {},
      isLoading: false,
      error: null
    },
    mutations: {
      setReviewEntryDetailList(state, { detailList }: { detailList: { [entryId: string]: ReviewEntryDetail[] } }) {
        state.reviewEntryDetailList = detailList
      },
      setReviewEntryDetailListByEntryId(
        state,
        { entryId, detailList }: { entryId: string; detailList: ReviewEntryDetail[] }
      ) {
        state.reviewEntryDetailList[entryId] = detailList
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchReviewEntryDetailList({ state, commit }, { entryId }: { entryId: string }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const detailList = await getByEntryIdReviewsUseCase.getByEntryIdReviews(entryId)
          commit('setReviewEntryDetailListByEntryId', { entryId, detailList })
        } catch (e) {
          commit('setError', e)
          commit('setReviewEntryDetailListByEntryId', { entryId, detailList: [] })
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      reviewEntryDetailList: state => state.reviewEntryDetailList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
